import { getAction, deleteAction, putAction, postAction, downFile, uploadFile } from './manage'
// 获取tickets列表
const getTicketsList = (baseUrl, token, params) => getAction(baseUrl + '/client/ticket', token, params);
// 获取tickets详情
const getTicketDetail = (baseUrl, token, id) => getAction(baseUrl + `/client/ticket/${id}`, token);
// 查询连天历史内容列表
const checkConversationHistory = (baseUrl, token, params) => getAction(baseUrl + '/common/ticket-conversation/history', token, params);
// 发送消息
const sendMessage = (baseUrl, token, params) => postAction(baseUrl + '/client/ticket-conversation', token, params);
// 上传文件
const uploads = (baseUrl, token, params) => uploadFile(baseUrl + '/upload/multi', token, params);
// 下载文件
const downloadFile = (baseUrl, token, params) => downFile(baseUrl + `/download/${params}`, token);
// 推荐回答
const recommend = (baseUrl, token, params) => getAction(baseUrl + '/client/recommend', token, params);
// 查询表单选项
const checkFormList = (baseUrl, token, params) => getAction(baseUrl + '/client/ticket/form', token, params);
// 保存ticket
const saveTicket = (baseUrl, token, params) => postAction(baseUrl + '/client/ticket/submit', token, params);
// 保存为草稿
const saveDraft = (baseUrl, token, params) => postAction(baseUrl + '/client/ticket/draft', token, params);
// resolve ticket
const resolveTicket = (baseUrl, token, params) => putAction(baseUrl + `/client/ticket/resolve/${params}`, token);
// reopen ticket
const reopenTicket = (baseUrl, token, params) => putAction(baseUrl + `/client/ticket/reopen/${params}`, token);
// delete ticket
const deleteTicket = (baseUrl, token, params) => deleteAction(baseUrl + `/client/ticket/pysical/${params}`, token);
// 为resolved状态的ticket打分
const haveScore = (baseUrl, token, params) => putAction(baseUrl + '/client/ticket/score', token, params);
// 查询草稿ticket详情
const checkDraftTicket = (baseUrl, token, params) => getAction(baseUrl + `/client/ticket/draft/${params}`, token);
// 根据url中的id查询展开
const getConversationDetail = (baseUrl, token, params) => getAction(baseUrl + '/client/ticket/page-num', token, params);
// 判断是否存在ticket id
const checkTicket = (baseUrl, token, params) => getAction(baseUrl + '/client/ticket/exist/' + params.id, token);
//分页获取历史记录
const hisByPage = (baseUrl, token, params) => getAction(baseUrl + '/common/ticket-conversation/history/list', token, params);
//新增投诉
const addComplaint = (baseUrl, token, params) => postAction(baseUrl + '/support/complaint', token, params);
//获取support头像
const assigneeAvatar = (baseUrl, token,params) => getAction(baseUrl + '/common/ticket/assignee/avatar',token,params);
// 删除消息
const deleteMsg = (baseUrl, token, id) => deleteAction(baseUrl + `/common/ticket-conversation/delete/${id}`, token);
// 将消息标记为已发送
const markAsSent = (baseUrl, token, params) => putAction(baseUrl + `/client/ticket-conversation/close-show`, token, params);

export {
  markAsSent,
  deleteMsg,
  getConversationDetail,
  checkDraftTicket,
  haveScore,
  deleteTicket,
  reopenTicket,
  resolveTicket,
  saveDraft,
  saveTicket,
  checkFormList,
  recommend,
  downloadFile,
  uploads,
  sendMessage,
  checkConversationHistory,
  getTicketsList,
  getTicketDetail,
  checkTicket,
  hisByPage,
  addComplaint,
  assigneeAvatar
}


// WEBPACK FOOTER //
// ./src/packages/chatBox/components/api.js